<template>
  <div class="box">
    <el-form  label-width="100px">
      <label
        style="
          font-weight: bold;
          margin-bottom: 20px;
          display: block;
          margin-left: 20px;
          margin-top: 20px;
        "
        >基本信息</label
      >
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名">
            <el-input
              v-model="userobj.commonPatName"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别">
            <el-input
              :value="userobj.commonPatSex == 'M' ? '男' : '女'"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄">
            <el-input
              v-model="userobj.commonPatAge"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="科别">
            <el-input
              v-model="userobj.deptName"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="门诊号">
            <el-input
              v-model="userobj.clinicNumber"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <label
        style="
          font-weight: bold;
          margin-bottom: 20px;
          display: block;
          margin-left: 20px;
        "
        >疾病信息</label
      >
      <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="主诉">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入主诉"
                v-model="userobj.actionInChief"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="现病史">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入现病史"
                v-model="userobj.historyPresentIllness"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="过敏史">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入过敏史"
                v-model="userobj.drugAllergyHistory"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="辅助检查结果">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入辅助检查结果"
                v-model="userobj.auxiliaryExamination"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="诊断">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入诊断"
                v-model="userobj.diagnose"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content">
            <el-form-item label="处理">
              <el-input
                type="textarea"
                :rows="3"
                :placeholder="treatmentOptionsPlaceholder"
                v-model="handle"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-form-item style="text-align: center">
        <el-button type="primary" @click="submitForm()">保存</el-button>
        <el-button style="margin-left: 30px" @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      userobj:{},
      treatmentOptionsPlaceholder:'',
      handle:''
    };
  },
  mounted() {
    this.userobj = JSON.parse(sessionStorage.getItem("editMedicalRecord"));
    this.handle=this.userobj.treatmentOptionsInput;
    let array=this.userobj.treatmentOptions.split('</br>');
    let str='';
    for(let i in array){
      str+=array[i]
    }
    this.treatmentOptionsPlaceholder=str;
  },
  methods: {
    cancel(){
      this.$router.push({ path: "medicalRecord" });
    },
    submitForm() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.user.book.case.history.update",
          userBookCaseHistoryId: that.userobj.id,
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
          auxiliaryExamination: that.userobj.auxiliaryExamination,
          drugAllergyHistory: that.userobj.drugAllergyHistory,
          actionInChief: that.userobj.actionInChief,
          actionInChief: that.userobj.actionInChief,
          diagnose: that.userobj.diagnose,
          commonPatId:that.userobj.commonPatId,
          treatmentOptions: that.userobj.treatmentOptions,
          treatmentOptionsInput:that.handle,
          clinicNumber: that.userobj.clinicNumber,
          historyPresentIllness:that.userobj.historyPresentIllness,
          token: localStorage.getItem("token"),
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            that.$message({
              type: "success",
              message: "保存成功!",
            });
            this.$router.push({ path: "medicalRecord" });
          }
        }
      );
    },
  },
  beforeDestroy(){
    window.sessionStorage.removeItem("editMedicalRecord");
  }
};
</script>
<style>
.box {
  background: #fff;
  overflow: hidden;
}
</style>